var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkoutsMobileNav(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.67188 3.21094H2.10938C1.72073 3.21094 1.40625 3.52542 1.40625 3.91406C1.40625 4.3027 1.72073 4.61719 2.10938 4.61719H5.67188C6.06052 4.61719 6.375 4.3027 6.375 3.91406C6.375 3.52542 6.06052 3.21094 5.67188 3.21094Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.67188 8.83594H2.10938C1.72073 8.83594 1.40625 9.15042 1.40625 9.53906C1.40625 9.9277 1.72073 10.2422 2.10938 10.2422H5.67188C6.06052 10.2422 6.375 9.9277 6.375 9.53906C6.375 9.15042 6.06052 8.83594 5.67188 8.83594Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.26562 6.02344H0.703125C0.314484 6.02344 0 6.33792 0 6.72656C0 7.1152 0.314484 7.42969 0.703125 7.42969H4.26562C4.65427 7.42969 4.96875 7.1152 4.96875 6.72656C4.96875 6.33792 4.65427 6.02344 4.26562 6.02344Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5938 9.53917H18.3281V6.72667C18.3281 5.4917 16.8174 4.84145 15.9272 5.73283L10.3026 11.3574C9.75329 11.9067 9.75329 12.7966 10.3026 13.3459L13.5271 16.5704L9.5995 20.498C9.05017 21.0474 9.05017 21.9372 9.5995 22.4866C10.1488 23.0358 11.0387 23.0359 11.588 22.4866L16.5099 17.5647C17.0592 17.0154 17.0592 16.1255 16.5099 15.5762L13.2854 12.3517L15.5156 10.1215V10.9454C15.5156 11.722 16.1453 12.3517 16.9219 12.3517H22.5938C23.3703 12.3517 24 11.722 24 10.9454C24 10.1688 23.3703 9.53917 22.5938 9.53917Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1316 2.39269C12.5727 2.02121 11.8311 2.09471 11.3573 2.56847L7.49012 6.43566C6.94079 6.98499 6.94079 7.87486 7.49012 8.42419C8.03945 8.97352 8.92937 8.97347 9.4787 8.42414L12.5308 5.37202L13.559 6.11264L14.9327 4.73893C15.1625 4.50914 15.4335 4.33078 15.7299 4.19152L13.1316 2.39269Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.30836 14.3403C8.95206 13.984 8.71421 13.5455 8.58882 13.0713L1.162 20.4981C0.612668 21.0474 0.612668 21.9373 1.162 22.4866C1.71128 23.0359 2.6012 23.036 3.15053 22.4866L10.3026 15.3346L9.30836 14.3403Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0312 5.32031C20.1962 5.32031 21.1406 4.37591 21.1406 3.21094C21.1406 2.04596 20.1962 1.10156 19.0312 1.10156C17.8663 1.10156 16.9219 2.04596 16.9219 3.21094C16.9219 4.37591 17.8663 5.32031 19.0312 5.32031Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkoutsMobileNav);
export default __webpack_public_path__ + "static/media/workouts-mobile-nav.df97270781e94fd5ac9b6a2ad7e5b032.svg";
export { ForwardRef as ReactComponent };